export default {
    gateAccessType: [
        'Ledger_Gate_Access',
        'Unit_Gate_Access',
        'Unit_Overlock_Status',
    ],
};
